// ── Enlaces de acceso: alta y recuperación ───────────────────────────
// provision-client.ts (easytek-ai) entrega el acceso con generate_link de Supabase. Al
// abrirlo, Supabase verifica el enlace y redirige al ITSM con la sesión en el hash:
// #access_token=...&refresh_token=...&type=invite (o type=recovery si la cuenta ya existía).
// Si el enlace venció o ya se usó, redirige con #error=...&error_code=otp_expired.
//
// Esto antes lo resolvía auth-js solo (detectSessionInUrl: true) con CUALQUIER sesión que
// viniera en la URL, y la escribía en la cookie compartida de .easytek.cr. Ahora solo se
// reconocen los dos tipos que manda la provisión, y AccessLinkGate pide un clic antes de
// adoptar nada. Una sesión de otro tipo pegada en un enlace (la forma del ataque) se descarta.
//
// Acá no se confía en nada del token: ni se valida ni se lee el correo del payload, que
// cualquiera puede escribir. De quién es la cuenta lo dice Supabase (usuarioDelToken).
const TIPOS_ACEPTADOS = ['invite', 'recovery'];

// Devuelve null si el hash no trae ni sesión ni error (lo normal), y si no:
//   { tipo: 'invite' | 'recovery', access_token, refresh_token }
//   { tipo: 'invalido' }  enlace vencido, usado o incompleto
//   { tipo: 'ignorado' }  sesión de otro tipo: no se adopta ni se muestra nada
export function leerEnlaceDeAcceso(hash) {
  const params = new URLSearchParams(String(hash || '').replace(/^#/, ''));
  if (params.get('error') || params.get('error_description')) return { tipo: 'invalido' };
  const access_token = params.get('access_token');
  if (!access_token) return null;
  const tipo = params.get('type');
  if (!TIPOS_ACEPTADOS.includes(tipo)) return { tipo: 'ignorado' };
  const refresh_token = params.get('refresh_token');
  if (!refresh_token) return { tipo: 'invalido' };
  return { tipo, access_token, refresh_token };
}

// Saca los tokens de la barra de direcciones (y del historial) sin cambiar de ruta. El
// estado del historial se conserva: es de React Router (guarda el idx para el botón atrás).
export function quitarHashDeLaUrl() {
  if (typeof window === 'undefined' || !window.location.hash) return;
  const { pathname, search } = window.location;
  window.history.replaceState(window.history.state, '', `${pathname}${search}`);
}
